import Voucher from './Voucher.js';
import Operations from './Operations.js';
import TextBoxModal from './TextBoxModal.js';
import FreeItemsModal from './FreeItemsModal.js';
import FeedBackModal from './FeedBackModal';
import BatchModal from './BatchModal.js';
import PlanListModel from './PlanListModel';
import GuideModal from './GuideModal';
import UIAdapter from './UIAdapter';
import Memo from './Memo';
import SerialNumber from './SerialNumber';
import MemberStore from './MemberStore';

export default [
    {name:'Voucher',model:Voucher},
    {name:'Operations',model:Operations},
    {name:'TextBoxModal',model:TextBoxModal},
    {name:'FreeItemsModal',model:FreeItemsModal},
    {name:'BatchModal',model:BatchModal},
    {name:'PlanListModel',model:PlanListModel},
    {name:'GuideModal',model:GuideModal},
    {name:'UIAdapter',model:UIAdapter},
    {name:'Memo',model:Memo},
    {name:'SerialNumber',model:SerialNumber},
    {name:'MemberStore',model:MemberStore},
    {name:'FeedBackModal',model:FeedBackModal}
]
